module.exports = __webpack_public_path__ + "static/media/tarjeta-oro.0261385c.png";